module.exports = "/_next/static/images/icon-whatsapp-c9b3d1d18a9c4c93d49e5ef51a3bf808.svg";